import { Avatar, Divider, Grid } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import { Skeleton } from '@material-ui/lab';
import { useStyles } from '@webapps/styles';

const TrainingsCardSkeleton = () => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);



  return (
    <div className={classes.container}>
      <CardContent className={css({ textAlign: 'center', padding: spacing(0, 0, 2.5, 0) })}>
        {/* Photo, Name and Edit Button Section */}
        <div className={css({
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: spacing(1)
        })}>
          <div className={css({
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            minWidth: 0,
            marginBottom: spacing(2)
          })}>
            <div className={css({ flexShrink: 0 })}>
              <Skeleton
                variant="circle"
                width={60}
                height={60}
                className={cx(classes.avatar, classes.skeletonColor)}
              />
            </div>
            <div className={css({
              marginLeft: spacing(2),
              flex: 1,
              minWidth: 0
            })}>
              <Skeleton
                variant="text"
                height={28}
                className={cx(css({
                  marginBottom: "10px",
                  width: '90%'
                }), classes.skeletonColor)}
              />
              <div className={cx(classes.name, global.infoText, global.frac)}>
                <Skeleton
                  variant="circle"
                  className={cx(classes.smallIcon, classes.skeletonColor)}
                />
                <Skeleton
                  variant="text"
                  height={20}
                  className={cx(css({
                    marginLeft: spacing(1),
                    width: '80%'
                  }), classes.skeletonColor)}
                />
              </div>
            </div>
          </div>
          <div className={css({ flexShrink: 0 })}>
            <Skeleton
              variant="circle"
              className={cx(classes.editButton, classes.skeletonColor)}
            />
          </div>
        </div>

        {/* Training Information Section */}
        {['85%', '65%', '95%', '55%', '75%', '80%', '70%', '60%'].map((width, index) => (
          <div key={index} className={cx(global.infoText, classes.address)}>
            <Skeleton
              variant="circle"
              className={cx(classes.infoIcon, classes.skeletonColor)}
            />
            <Skeleton
              variant="text"
              height={20}
              className={cx(css({
                marginLeft: spacing(1),
                width: width
              }), classes.skeletonColor)}
            />
          </div>
        ))}

        <Divider className={classes.divider} />

        {/* Cost and Mobility Section */}
        {['95%', '85%'].map((width, index) => (
          <div key={index} className={cx(global.infoText, classes.address)}>
            <Skeleton
              variant="circle"
              className={cx(classes.infoIcon, classes.skeletonColor)}
            />
            <Skeleton
              variant="text"
              height={20}
              className={cx(css({
                marginLeft: spacing(1),
                width: width
              }), classes.skeletonColor)}
            />
          </div>
        ))}

        <Divider className={classes.divider} />

        {/* Students and Contracts Section */}
        {['60%', '80%', '70%', '90%'].map((width, index) => (
          <div key={index} className={cx(global.infoText, classes.address)}>
            <Skeleton
              variant="circle"
              className={cx(classes.infoIcon, classes.skeletonColor)}
            />
            <Skeleton
              variant="text"
              height={20}
              className={cx(css({
                marginLeft: spacing(1),
                width: width
              }), classes.skeletonColor)}
            />
          </div>
        ))}

        <Divider className={classes.divider} />

        {/* OPCO and Billing Section */}
        {['65%', '50%'].map((width, index) => (
          <div key={index} className={cx(global.infoText, classes.address)}>
            <Skeleton
              variant="circle"
              className={cx(classes.infoIcon, classes.skeletonColor)}
            />
            <Skeleton
              variant="text"
              height={20}
              className={cx(css({
                marginLeft: spacing(1),
                width: width
              }), classes.skeletonColor)}
            />
          </div>
        ))}
      </CardContent>

      {/* Buttons Section */}
      <div className={classes.buttons}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Skeleton
              variant="rect"
              width="100%"
              height={36}
              className={cx(css({ borderRadius: 4 }), classes.skeletonColor)}
            />
          </Grid>
          <Grid item xs={6}>
            <Skeleton
              variant="rect"
              width="100%"
              height={36}
              className={cx(css({ borderRadius: 4 }), classes.skeletonColor)}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    backgroundColor: "white",
    borderRadius: 16,
    padding: spacing(2.5),
  },
  name: {
    display: 'flex',
    textAlign: 'start',
    fontFamily: 'Montserrat',
    wordBreak: 'break-all',
  },
  divider: {
    margin: "8px 0px",
  },
  address: {
    display: 'flex',
    marginTop: spacing(0.5),
    textAlign: 'start',
    alignItems: 'center',
  },
  avatar: {
    height: 60,
    width: 60,
    border: '1px solid #C0D9FF',
  },

  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    rowGap: 10,
  },
  smallIcon: {
    width: 16,
    height: 16,
    flexShrink: 0,
  },
  infoIcon: {
    width: 20,
    height: 20,
    flexShrink: 0,
  },
  editButton: {
    width: 32,
    height: 32,
    flexShrink: 0,
  },
  skeletonColor: {
    backgroundColor: '#D6E7FF !important',
    '&::after': {
      background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)',
    }
  }
});

export default TrainingsCardSkeleton; 